// Function to log all potential picker elements
function logAllPickers(sectionId, context) {
  const selects = document.querySelectorAll(
    `#variant-selects-${sectionId} select, #product-form-${sectionId} select`
  );
  selects.forEach((select, index) => {
  });
  const variantInput = document.querySelector(`#product-form-${sectionId} input[name="id"]`);
}

// Function to log the state of the size picker
function logPickerState(sectionId, context) {
  const sizeSelect = document.querySelector(
    `#variant-selects-${sectionId} select[data-option-name="Size" i], ` +
    `#variant-selects-${sectionId} select[data-option-name="size" i], ` +
    `#variant-selects-${sectionId} select[data-option-name="SIZE" i], ` +
    `#variant-selects-${sectionId} select[data-option-name="Ring Size" i], ` +
    `#variant-selects-${sectionId} select[data-option-name="ring size" i], ` +
    `#variant-selects-${sectionId} select[data-option-name="RING SIZE" i], ` +
    `#variant-selects-${sectionId} select[name="options[Size]" i], ` +
    `#variant-selects-${sectionId} select[name="options[size]" i], ` +
    `#variant-selects-${sectionId} select[name="options[SIZE]" i], ` +
    `#variant-selects-${sectionId} select[name="options[Ring Size]" i], ` +
    `#variant-selects-${sectionId} select[name="options[ring size]" i], ` +
    `#variant-selects-${sectionId} select[name="options[RING SIZE]" i], ` +
    `#product-form-${sectionId} select[data-option-name="Size" i], ` +
    `#product-form-${sectionId} select[data-option-name="size" i], ` +
    `#product-form-${sectionId} select[data-option-name="SIZE" i], ` +
    `#product-form-${sectionId} select[data-option-name="Ring Size" i], ` +
    `#product-form-${sectionId} select[data-option-name="ring size" i], ` +
    `#product-form-${sectionId} select[data-option-name="RING SIZE" i], ` +
    `#product-form-${sectionId} select[name="options[Size]" i], ` +
    `#product-form-${sectionId} select[name="options[size]" i], ` +
    `#product-form-${sectionId} select[name="options[SIZE]" i], ` +
    `#product-form-${sectionId} select[name="options[Ring Size]" i], ` +
    `#product-form-${sectionId} select[name="options[ring size]" i], ` +
    `#product-form-${sectionId} select[name="options[RING SIZE]" i]`
  );
  if (!sizeSelect) {
    logAllPickers(sectionId, context);
    return null;
  }
  const variantInput = document.querySelector(`#product-form-${sectionId} input[name="id"]`);
  return sizeSelect;
}

// Function to get the selected size from the variant picker
function getSelectedSize(sectionId) {
  const sizeSelect = logPickerState(sectionId, 'getSelectedSize');
  if (!sizeSelect) return null;
  const value = sizeSelect.value;
  if (!value || value === '') {
    return null;
  }
  const size = value.toUpperCase();
  return size;
}

// Function to set the size in the variant picker
function setSelectedSize(sectionId, size) {
  if (!size) {
    return;
  }
  const sizeSelect = logPickerState(sectionId, 'setSelectedSize Before');
  if (!sizeSelect) return;
  const matchingOption = Array.from(sizeSelect.options).find(option => option.value.toUpperCase() === size);
  if (!matchingOption) {
    return;
  }
  sizeSelect.value = matchingOption.value;
  // Trigger change event
  const changeEvent = new Event('change', { bubbles: true });
  sizeSelect.dispatchEvent(changeEvent);
  // Update the variant ID
  const variantDataElement = document.querySelector(`#variant-data-${sectionId}`);
  if (!variantDataElement) {
    return;
  }
  const variantData = JSON.parse(variantDataElement.textContent);
  const selectedOptions = Array.from(document.querySelectorAll(`#variant-selects-${sectionId} select`)).map(select => select.value);
  const selectedVariant = variantData.find(variant => {
    return variant.options.every((option, index) => {
      return selectedOptions[index] ? option.toUpperCase() === selectedOptions[index].toUpperCase() : true;
    });
  });
  if (selectedVariant) {
    const variantInput = document.querySelector(`#product-form-${sectionId} input[name="id"]`);
    if (variantInput) {
      variantInput.value = selectedVariant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      // Publish variantChange event for product-info.js
      if (typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: sectionId,
            html: document,
            variant: selectedVariant
          }
        });
      }
    }
  }
  logPickerState(sectionId, 'setSelectedSize After');
}

// Function to save size to localStorage
function saveSize(size) {
  if (size && size !== '') {
    localStorage.setItem('preferredSize', size);
  }
}

// Function to load size from localStorage
function loadSize() {
  const size = localStorage.getItem('preferredSize');
  return size;
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  const mainProduct = document.querySelector('[id^="MainProduct-"]');
  if (!mainProduct) {
    return;
  }
  const sectionId = mainProduct.dataset.section;
  logAllPickers(sectionId, 'DOMContentLoaded Initial');
  const savedSize = loadSize();
  if (savedSize) {
    setSelectedSize(sectionId, savedSize);
  }
  const sizeSelect = document.querySelector(
    `#variant-selects-${sectionId} select[data-option-name="Size" i], ` +
    `#variant-selects-${sectionId} select[data-option-name="size" i], ` +
    `#variant-selects-${sectionId} select[data-option-name="SIZE" i], ` +
    `#variant-selects-${sectionId} select[data-option-name="Ring Size" i], ` +
    `#variant-selects-${sectionId} select[data-option-name="ring size" i], ` +
    `#variant-selects-${sectionId} select[data-option-name="RING SIZE" i], ` +
    `#variant-selects-${sectionId} select[name="options[Size]" i], ` +
    `#variant-selects-${sectionId} select[name="options[size]" i], ` +
    `#variant-selects-${sectionId} select[name="options[SIZE]" i], ` +
    `#variant-selects-${sectionId} select[name="options[Ring Size]" i], ` +
    `#variant-selects-${sectionId} select[name="options[ring size]" i], ` +
    `#variant-selects-${sectionId} select[name="options[RING SIZE]" i], ` +
    `#product-form-${sectionId} select[data-option-name="Size" i], ` +
    `#product-form-${sectionId} select[data-option-name="size" i], ` +
    `#product-form-${sectionId} select[data-option-name="SIZE" i], ` +
    `#product-form-${sectionId} select[data-option-name="Ring Size" i], ` +
    `#product-form-${sectionId} select[data-option-name="ring size" i], ` +
    `#product-form-${sectionId} select[data-option-name="RING SIZE" i], ` +
    `#product-form-${sectionId} select[name="options[Size]" i], ` +
    `#product-form-${sectionId} select[name="options[size]" i], ` +
    `#product-form-${sectionId} select[name="options[SIZE]" i], ` +
    `#product-form-${sectionId} select[name="options[Ring Size]" i], ` +
    `#product-form-${sectionId} select[name="options[ring size]" i], ` +
    `#product-form-${sectionId} select[name="options[RING SIZE]" i]`
  );
  if (sizeSelect) {
    sizeSelect.addEventListener('change', (event) => {
      const selectedSize = event.target.value.toUpperCase();
      saveSize(selectedSize);
    });
  } else {
    logAllPickers(sectionId, 'DOMContentLoaded Fallback');
  }
});